function PhysicianDetailsMeedyVO(title, firstSpecialization, secondSpecialization, allowChildren, childrenAgeLowerLimit,
                                 childrenAgeUpperLimit, pesel, pwz, workInHospital, aboutMe, experience) {

    this.title = title;
    this.firstSpecialization = firstSpecialization;
    this.secondSpecialization = secondSpecialization;
    this.allowChildren = allowChildren === true;
    this.childrenAgeLowerLimit = childrenAgeLowerLimit;
    this.childrenAgeUpperLimit = childrenAgeUpperLimit;
    this.pesel = pesel;
    this.pwz = pwz;
    this.workInHospital = workInHospital === true;
    this.aboutMe = aboutMe;
    this.experience = experience;

    var _typeContext = {
        firstSpecialization : SpecializationMeedyVO,
        secondSpecialization : SpecializationMeedyVO
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
